// Types
import { AuthState, SocialInfo } from 'types'

// Utils
import { getAuthToken } from 'modules/auth/actions'

const localToken = getAuthToken()

export const initialState: AuthState = {
  adminModeActive: false,
  isAuthenticated: false,
  profileId: 0,
  showAuthModal: false,
  socialinfo: null,
  token: localToken,
  userId: 0,
}

type AuthReducableActions = {
  type:
    | 'TOGGLE_ADMIN_MODE'
    | 'AUTH_LOGIN_ERROR'
    | 'AUTH_LOGOUT_DONE'
    | 'AUTH_SHOW_LOGIN_MODAL'
    | 'AUTH_HIDE_LOGIN_MODAL'
    | 'AUTH_CHECK_ERROR'
    | 'AUTH_REMOVE_TOKEN'
}
type AuthRegisterDoneAction = {
  type: 'AUTH_REGISTER_DONE'
  data: {
    response: {
      key: string
    }
  }
}

type AuthCheckSuccess = {
  type: 'AUTH_CHECK_SUCCESS'
  data: number
}

type AuthSetPreview = {
  type: 'AUTH_SET_PREVIEW'
  data: SocialInfo
}

type AuthActions = AuthReducableActions | AuthRegisterDoneAction | AuthCheckSuccess | AuthSetPreview

const reducer = (state: AuthState = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case 'TOGGLE_ADMIN_MODE':
      return {
        ...state,
        adminModeActive: !state.adminModeActive,
      }

    case 'AUTH_LOGIN_ERROR':
      return {
        ...state,
        token: '',
        isAuthenticated: false,
      }

    case 'AUTH_REGISTER_DONE':
      return {
        ...state,
        token: action.data.response.key,
      }

    case 'AUTH_LOGOUT_DONE':
      return {
        ...state,
        token: '',
        isAuthenticated: false,
        profileId: 0,
      }

    case 'AUTH_SHOW_LOGIN_MODAL':
      return {
        ...state,
        showAuthModal: true,
      }

    case 'AUTH_HIDE_LOGIN_MODAL':
      return {
        ...state,
        showAuthModal: false,
      }

    case 'AUTH_CHECK_SUCCESS':
      return {
        ...state,
        isAuthenticated: true,
        profileId: action.data,
        token: getAuthToken(),
      }

    case 'AUTH_CHECK_ERROR':
      return {
        ...state,
        isAuthenticated: false,
        token: '',
        profileId: 0,
      }

    case 'AUTH_SET_PREVIEW':
      return {
        ...state,
        socialinfo: action.data,
      }

    case 'AUTH_REMOVE_TOKEN': {
      return {
        ...state,
        token: '',
      }
    }
    default:
      return state
  }
}
export default reducer
